
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin, BAIconsMixin, RoutingMixin } from "@/mixins";

@Component
export default class LinkText extends Mixins(VuetifyMixin, BAIconsMixin, RoutingMixin) {
	@Prop({ default: "" }) href: string;
	@Prop({ default: "" }) tooltip: string;
	@Prop({ default: "_blank" }) target: string;
	@Prop({ type: Boolean }) hrefDisabled;
	@Prop({ type: Boolean }) small;

	get HREFAttribute(): string | null {
		return this.hrefDisabled ? null : 'href'
	}

	get Tooltip(): string {
		if( this.IsNotEmpty(this.tooltip) ) return this.tooltip;
		if( this.IsEmpty(this.href) ) return "Follow this link"
		return `Link: ${this.href}`;
	}

	get Class(): string {
		if( this.small ) return 'text-caption';
		return '';
	}

	onClick() {
		this.$emit('click');
		if( this.hrefDisabled ) return;
		if( this.IsNotEmpty(this.href) ) this.gotoUrl(this.href, this.target);
	}
}
